import React from 'react';
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function FutureIngestionNotice({ proposal, futureOnly = false }) {
  const { t } = useTranslation();
  if (!proposal) return null;
  return <Alert severity="info">{t(proposal.operation === 'remove' ? 'project_chat.ingestion.remove' :
    futureOnly ? 'project_chat.ingestion.future_only' : 'project_chat.ingestion.publish', {
      variable: proposal.variable,
      types: proposal.extensions?.length ? proposal.extensions.join(', ') : t('project_chat.ingestion.all_types')
    })}</Alert>;
}
